import { POPULATION_TYPE } from "@/common/models";

interface TrustedModalEntity {
  id: string;
  name: string;
  type: POPULATION_TYPE;
}

const create_props = async (
  entity: TrustedModalEntity,
  info_types: string[]
) => {
  const { SharedState } = await import("@/common/state");
  info_types = info_types.map((id) => {
    const { generation, code } = SharedState.allInfoTypes.value[id];
    if (generation > 0) {
      const type = SharedState.l0InfoTypes.value.find(
        (l0) => l0.code === code
      )!;
      return type.id;
    } else {
      return id;
    }
  });
  return {
    entity,
    info_types,
  };
};

export const ManageTrustedModalHelper = {
  create_props,
};
